import apiProtected from '@lib/api/apiClient';
import { server } from '@lib/api/http';
import axios from 'axios';

export type UploadFolder =
  | 'profilePics'
  | 'chat'
  | `job-ratings-media/${string}`;

interface PresignedUpload {
  uploadUrl: string;
  fileUrl: string;
  key: string;
  headers: Record<string, string>;
}

export interface UploadedFile {
  location: string;
  key: string;
}

export const uploadFile = async (
  file: File,
  folder: UploadFolder
): Promise<UploadedFile> => {
  const { data } = await apiProtected.post<{ data: PresignedUpload }>(
    `${server}v1/uploads/presigned-url`,
    {
      folder,
      fileName: file.name || 'file',
      contentType: file.type || 'application/octet-stream',
    }
  );
  const { uploadUrl, fileUrl, key, headers } = data.data;

  // Plain axios so S3 doesn't receive the app's Authorization header
  await axios.put(uploadUrl, file, { headers });

  return { location: fileUrl, key };
};
